// extracted by mini-css-extract-plugin
module.exports = {"FullWidth":"full-width_FullWidth__1pp_j","Article":"full-width_Article__30_jr","image":"full-width_image__NcdJK"};